import script from "./ExamTestShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamTestShow.vue?vue&type=script&setup=true&lang=ts"

import "./ExamTestShow.vue?vue&type=style&index=0&id=ba62ad8c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba62ad8c"]])

export default __exports__